import React from 'react';
import { Check } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';
import { LeadForm } from './LeadForm';
export function ContactForm() {
  const {
    t
  } = useLang();
  const c = t.contact;
  return <section id="contacto" className="py-24 bg-dark border-t border-white/5" data-id="element-2" data-mp="14s0afdmr1wpa">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3" data-mp="ztyqkqhi1tcr">
        <div className="grid lg:grid-cols-5 gap-12 lg:gap-16 items-start" data-id="element-4" data-mp="zsdyd7inqmi2">
          {/* Left: pitch */}
          <div className="lg:col-span-2 lg:sticky lg:top-32" data-id="element-5" data-mp="8311rxi96swk">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-6" data-mp="84ls1axjbpom">
              {c.title} <span className="text-gold" data-id="element-7" data-mp="lvqmzzpyjtsm">{c.titleHighlight}</span>
            </h2>
            <p className="text-lg text-gray-400 mb-8" data-id="element-8" data-mp="h2xjtga50tin">{c.subtitle}</p>
            <ul className="space-y-4" data-id="element-9" data-mp="3pj0ore9v843a">
              {c.points.map(point => <li key={point} className="flex items-center gap-3" data-id="element-10" data-mp="3kkfstr1nc6kn">
                  <span className="bg-gold/20 p-1 rounded-full shrink-0" data-id="element-11" data-mp="3kid1n3orc7ec">
                    <Check className="w-4 h-4 text-gold" data-id="element-12" data-mp="3pkdmrgtny1uf" />
                  </span>
                  <span className="text-white font-medium" data-id="element-13" data-mp="3uj82g9wc3aab">{point}</span>
                </li>)}
            </ul>
          </div>

          {/* Right: form */}
          <div className="lg:col-span-3 bg-dark-100 border border-white/10 rounded-3xl p-6 md:p-10" data-id="element-14" data-mp="84fa5nzl9eei">
            <LeadForm idPrefix="contact" data-id="element-15" data-mp="36mkjgdf4npwi" />
          </div>
        </div>
      </div>
    </section>;
}